var _module_exports = "<div class=\"ep-EntryPopUp\" ng-class=\"{'is-open': showPopup===true}\">\n  <div class=\"ep-EntryPopUp_Inner loading_popup\">\n\n\n      <div class=\"loading_popup__spinner\"><i class=\"fa fa-spinner fa-spin\" aria-hidden=\"true\"></i></div>\n      <p class=\"loading_popup__message\">You're on your way to savings!</p>\n\n  </div>\n</div>\n";;
var path = '/containers/users/views/partials/loading-popup.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./js/containers/users/views/partials/loading-popup.html
// module id = 779
// module chunks = 0